import { render, staticRenderFns } from "./vNutritionLabelCanada.vue?vue&type=template&id=938cb3d0&scoped=true"
import script from "./vNutritionLabelCanada.vue?vue&type=script&lang=ts"
export * from "./vNutritionLabelCanada.vue?vue&type=script&lang=ts"
import style0 from "./vNutritionLabelCanada.vue?vue&type=style&index=0&id=938cb3d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938cb3d0",
  null
  
)

export default component.exports